import { Capacitor } from "@capacitor/core";
import { LocalNotifications } from "@capacitor/local-notifications";

const NATIVE_PERMISSION_KEY = "mygoal-native-notification-permission";

const isNativeNotificationsSupported = () => {
  try {
    return Capacitor.getPlatform() === "android";
  } catch (error) {
    return false;
  }
};

const setNativePermission = (value) => {
  localStorage.setItem(NATIVE_PERMISSION_KEY, value);
};

// Push Notifications Service
export const NotificationService = {
  isSupported: () => {
    try {
      if (isNativeNotificationsSupported()) return true;
      return typeof window !== 'undefined' && 'Notification' in window && typeof Notification !== 'undefined';
    } catch (e) {
      return false;
    }
  },
  
  getPermission: () => {
    try {
      if (isNativeNotificationsSupported()) {
        return localStorage.getItem(NATIVE_PERMISSION_KEY) || 'default';
      }
      if (!NotificationService.isSupported()) return 'denied';
      return Notification.permission;
    } catch (e) {
      return 'denied';
    }
  },
  
  requestPermission: async () => {
    if (!NotificationService.isSupported()) {
      console.log('Notifications not supported');
      return false;
    }
    
    try {
      if (isNativeNotificationsSupported()) {
        const current = await LocalNotifications.checkPermissions();
        if (current.display === 'granted') {
          setNativePermission('granted');
          return true;
        }

        const requested = await LocalNotifications.requestPermissions();
        setNativePermission(requested.display);
        return requested.display === 'granted';
      }

      const permission = await Notification.requestPermission();
      return permission === 'granted';
    } catch (e) {
      console.log('Notification permission error:', e);
      return false;
    }
  },
  
  scheduleRatingReminder: () => {
    if (!NotificationService.isSupported() || NotificationService.getPermission() !== 'granted') return;
    
    const now = new Date();
    const reminderHour = 21; // 9 PM
    
    if (now.getHours() >= reminderHour) {
      NotificationService.showNotification(
        '📝 Rate Your Training!',
        "Don't forget to rate yesterday's training session. Tap to open MyGoal."
      );
    }
  },
  
  showNotification: (title, body, options = {}) => {
    if (!NotificationService.isSupported() || NotificationService.getPermission() !== 'granted') {
      return null;
    }
    
    try {
      if (isNativeNotificationsSupported()) {
        LocalNotifications.schedule({
          notifications: [{
            id: Math.floor(Math.random() * 1000000),
            title,
            body,
            schedule: { at: new Date(Date.now() + 500) },
          }],
        });
        return true;
      }

      return new Notification(title, {
        body,
        icon: '/favicon.ico',
        badge: '/favicon.ico',
        tag: 'mygoal-notification',
        requireInteraction: true,
        ...options
      });
    } catch (e) {
      console.log('Notification error:', e);
      return null;
    }
  },
  
  testNotification: () => {
    if (!NotificationService.isSupported()) {
      return false;
    }
    NotificationService.showNotification(
      '🎯 MyGoal Reminder',
      "Time to rate your training! How was yesterday's session?"
    );
    return true;
  }
};

export default NotificationService;
